export const data3_2_1 = [{
    name: "Jan 一月",
    actual: 0,
    budget: 0,
    var: 0,
    completion: 0
}, {
    name: "Feb 二月",
    actual: 0,
    budget: 0,
    var: 0,
    completion: 0
}, {
    name: "Mar 三月",
    actual: 0,
    budget: 0,
    var: 0,
    completion: 0
}, {
    name: "Apr 四月",
    actual: 0,
    budget: 0,
    var: 0,
    completion: 0
}, {
    name: "May 五月",
    actual: 0,
    budget: 0,
    var: 0,
    completion: 0
}, {
    name: "Jun 六月",
    actual: 0,
    budget: 0,
    var: 0,
    completion: 0
}, {
    name: "Jul 七月",
    actual: 0,
    budget: 0,
    var: 0,
    completion: 0
}, {
    name: "Aug 八月",
    actual: 0,
    budget: 0,
    var: 0,
    completion: 0
}, {
    name: "Sep 九月",
    actual: 0,
    budget: 0,
    var: 0,
    completion: 0
}, {
    name: "Oct 十月",
    actual: 0,
    budget: 0,
    var: 0,
    completion: 0
}, {
    name: "Nov 十一月",
    actual: 0,
    budget: 0,
    var: 0,
    completion: 0
}, {
    name: "Dec 十二月",
    actual: 0,
    budget: 0,
    var: 0,
    completion: 0
}, {
    name: "YTD 年累计",
    actual: 0,
    budget: 0,
    var: 0,
    completion: 0
}]; 



// WEBPACK FOOTER //
// ./src/components/table/2-Analysis/2-8/data.js